module.exports = __webpack_public_path__ + "img/crawling.aa1e1776.png";